import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import InstructionsButton from './InstructionsHighlightButton';

const useStyles = makeStyles(() => ({
  root: {
    fontSize: '0.85rem',
    fontWeight: 400,
  },
}));

const InstructionsHighlight = ({ className = '' }) => {
  const classes = useStyles();

  return (
    <div className={`${classes.root} ${className}`}>
      <div className="instructions-text">
        <InstructionsButton />
      </div>
    </div>
  );
};

export default InstructionsHighlight;
